<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "TicketChat",
  data() {
    return {}
  },
  props: {},
  methods: {},
})
</script>

<template>
  <div class="ticket-chat">
    <div class="chat-header">
      <div class="d-flex align-items-center gap-3">
        <b-avatar size="40" variant="danger"></b-avatar>
        <div class="user-info ml-2">
          <p class="user-name mb-0">Lina_Inverse</p>
          <span class="user-source">Со страницы: Профиль</span>
        </div>
      </div>
    </div>
    <div class="chat-messages">
    </div>
    <div class="chat-input">
      <b-input placeholder="Введите сообщение"/>
    </div>
  </div>
</template>

<style scoped lang="scss">
.ticket-chat {
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background: white;
  overflow: hidden;
}

.chat-header {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
}

.user-info {
  .user-name {
    font-size: 16px;
    color: #212529;
    font-weight: 600;
    line-height: 1.2;
  }

  .user-source {
    font-size: 12px;
    color: #6c757d;
  }
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}

.chat-input {
  padding: 1rem;
  border-top: 1px solid #dee2e6;
  background: #f8f9fa;
}
</style>